// forked from loglevel-localStorage https://github.com/gpcboekema/loglevel-localStorage

/* eslint-disable */
var _ = require('lodash');

/**
 * @description
 * Extend loglevel with new plugin which will send log information to the log-sever
 *
 * @param {object} logger loglevel instance to be extended
 * @param {object} options
 * @param {string} [options.storeKey='loglevelLocalStorage'] Name for the store in localStorage.
 * @param {number} [options.maxLogStackSize=100] Max stack size to store.
 * @param {boolean} [options.callOriginal=false] If set to true - original loglevel method for logging would be called
 * @param {string|Function} [options.prefix=null] Prefix for all log messages. Either string or function wich should return string and accept log severity and message as parameters
 * @param {string|number} [options.level=logger.levels.WARN] Log level. Either string or number, {@see logger.setLevel}.
 * @example
 * loglevelLocalStorage(log,{level:'info',prefix: function(logSev,message) {
 *     return '[' + new Date().toISOString() + '] ' + logSev + ': ' + message;
 * }})
 */

var loglevelLocalStorage = function loglevelLocalStorage(logger, options, cb) {
    if (!logger || !logger.methodFactory) throw new Error('loglevel instance has to be specified in order to be extended');

    var _logger = logger,
        _storeKey = options && options.storeKey || 'loglevelLocalStorage',
        // _maxLogStackSize = options && options.maxLogStackSize || 100,
        _callOriginal = options && options.callOriginal || false,
        _prefix = options && options.prefix,
        _level = options && options.level || _logger.levels.WARN,
        _originalFactory = _logger.methodFactory;
        // _logStackLocalStorage = [];

    if (!options.persistentLog) {
        window.localStorage.removeItem(_storeKey);
    }

    _logger.methodFactory = function (methodName, logLevel) {
      var rawMethod = _originalFactory(methodName, logLevel);

        return function (/* ...message */) {
            if (_callOriginal) {
                rawMethod.apply(null, arguments);
            }

            let methodNameLevel = 0;

            switch (methodName) {
                case 'trace': methodNameLevel = 0; break;
                case 'debug': methodNameLevel = 1; break;
                case 'info': methodNameLevel = 2; break;
                case 'log': default: methodNameLevel = 2; break;
                case 'warn': methodNameLevel = 3; break;
                case 'error': methodNameLevel = 4; break;
            }

            if (methodNameLevel < _level) {
                return;
            }

            var args = Array.prototype.slice.call(arguments, 0);

            var message;
            if (typeof _prefix === 'string') {
                message = _prefix + args.join(' ');
            } else if (typeof _prefix === 'function') {
                message = _prefix.apply(null, Array.prototype.concat.apply([methodName], args));
            } else {
                message = methodName + ': ' + args.join(' ');
            }

            // const logStack = JSON.parse(window.localStorage.getItem(_storeKey) || '[]');
            // logStack.push(message);

            // // Always store a max of {_maxLogStackSize} logs.
            // _logStackLocalStorage = logStack.slice(-_maxLogStackSize);

            // Store to localStorage.
            // _storeLogStack();
        };
    };

    // var _storeLogStack = function _storeLogStack() {
    //     try {
    //         if (!_logStackLocalStorage.length) return;
    
    //         window.localStorage.setItem(_storeKey, JSON.stringify(_logStackLocalStorage));
    //     } catch (error) {
    //         if(cb)cb(error);
    //     }
    // };
};

export default loglevelLocalStorage